import authHeader from "../helpers/authHeader";
import userService from "./userService";
import history from "../helpers/history";

const updatePersonalInfo = async (personalInfo) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(personalInfo),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/ApplicationUser/UpdateUserInfo`,
    requestOptions
  )
    .then(handleResponse)
    .then((userInfo) => {
      return userInfo;
    });
};

const updatePassword = async (updatePass) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(updatePass),
  };
  //console.log("login request");
  return await fetch(
    `${process.env.REACT_APP_API_URL}/ApplicationUser/UpdatePassword`,
    requestOptions
  )
    .then(handleResponse)
    .then((data) => {
      if (data.code === "PasswordUpdated") {
        userService.logout();
        history.push("/");
      }
      //console.log(data);
      return;
    });
};

const handleResponse = (response) => {
  //console.log(response);
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        userService.logout();
        history.push("/");
      }
      if (response.status === 400) {
      }
      const error =
        response.status === 400
          ? data.isArray(data)
            ? data.map((a) => a.description)
            : data.description
          : (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
};

const personalInfoService = { updatePersonalInfo, updatePassword };

export default personalInfoService;
